var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaurel = function SvgLaurel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 39,
    fill: "none",
    viewBox: "0 0 18 38"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    fillRule: "evenodd",
    d: "M13.434 14.19c.303.797.46 1.904 1.603.659 1.951-2.128.428-6.157.323-6.13 0 0-1.9 2.182-2.076 3.91-.081.8-.005.782.15 1.562",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A97D",
    fillRule: "evenodd",
    d: "M5.648 8.156c.174.079 1.597 1.034 3.391.338.144-.056.82-.318-.663-1.817C6.94 5.224 3.072 5.34 3.14 5.622c.203.848 2.279 2.366 2.509 2.534M10.344 34.94c.076-.037 1.1-.364 2.728-1.751.713-.607-2.5-.783-2.727-.796-2.596-.142-4.076 2.064-3.707 2.246 2.096 1.03 3.267.414 3.706.3",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    fillRule: "evenodd",
    d: "M6.997 4.147c.157.304.465 1.444 2.222 2.209.363.157 1.378-2.11-.58-4.58C8.513 1.617 6.866-.46 6.746.094c-.378 1.743.166 3.74.251 4.053",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A97D",
    fillRule: "evenodd",
    d: "M14.618 27.493c.546-.307 1.814-.74 3.212-3.832.22-.487-.2-.4-.235-.393-1.055.218-4.7.966-4.97 4.071-.059.688 1.508.227 1.993.154M11.871 18.489c.865.31 1.805.982 1.628-.498-.058-.486-.381-3.189-4.122-4.52-.46-.163.366 3.6 1.812 4.62.052.036.05.03.682.398",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    fillRule: "evenodd",
    d: "M10.297 20.873c.02.06.44 2.677 3.06 3.33.518.13.847-2.437-.934-4.135-1.207-1.151-2.426-1.898-2.451-1.692-.062.498.287 2.3.325 2.497M2.699 32.884c-.065.212-.62 2.026-.099 2.77.467.667 3.693-1.46 3.412-5.704-.022-.322-.925.371-.993.424-1.832 1.405-1.817 1.654-2.32 2.51",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A97D",
    fillRule: "evenodd",
    d: "M11.712 25.147c-.206-.417-.416-1.141-1.882-2.656-.05-.051-.747-.772-.822-.347-.867 4.959 2.2 6.337 2.516 6.083.813-.652.25-2.841.188-3.08",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    fillRule: "evenodd",
    d: "M17.362 16.942c.082-.24.643-1.887.675-3.094.009-.33-1.613.749-2.135 1.182-2.536 2.104-1.822 4.51-1.48 4.492 1.763-.097 2.806-2.297 2.94-2.58M3.191 4.267c.231.105 2.223 1.015 3.161.328.094-.069.09-2.787-4.242-3.373C.604 1.018.54 1.226.6 1.332c.98 1.785 2.336 2.753 2.591 2.935",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A97D",
    fillRule: "evenodd",
    d: "M11.23 9.54c.812 1.078 1.313 1.712 1.83.465.716-1.732.33-2.961-.802-4.794-.217-.35-.863-1.618-1.093-.752-.934 3.529-.44 3.823.065 5.081",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    fillRule: "evenodd",
    d: "M10.202 30.785c-.095.334-.435.926.989.89.468-.011 3.02-.074 4.797-3.363.15-.28-1.812-.238-2.871.114-1.956.65-2.187.956-2.916 2.36",
    clipRule: "evenodd"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#B4A97D",
    fillRule: "evenodd",
    d: "M17.13 18.854c-.39.235-2.16 1.001-2.686 2.964-.494 1.841.265 1.683.398 1.655 2.719-.567 3.415-3.076 3.882-4.875.07-.27.075-.417-.179-.324-.115.043-.105.043-1.415.58M6.85 30.511c.332.579 1.165 3.068 2.274.105.733-1.962-1.146-5.694-1.39-5.151-1.581 3.501-1.091 4.221-.884 5.046",
    clipRule: "evenodd"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#9B8D52",
    fillRule: "evenodd",
    d: "M3.848 38.218c1.28.384 1.41.52 4.029-.568.003 0 1.803-.86 1.396-1.137-.282-.192-2.882-1.136-4.362-.635-.198.067-1.742.59-2.157 1.477-.209.449.839.75 1.094.863M12.646 12.943c-.321-.862-.535-1.99-2.53-2.922-.592-.276-2.876-1.133-2.695-.66 1.556 4.085 3.445 4.17 4.559 4.264.984.084.676-.412.665-.682M1.149 38.338c1.845-.953-.552-2.546-1.091-1.168-.161.413.052.778.086.836.327.557.922.343 1.005.332",
    clipRule: "evenodd"
  })));
};
export default SvgLaurel;